import { CHARTER_MARKETS, MARKETS, Markets } from '@packages/locale/constants/locales.ts'
import type { Market } from '@packages/locale/types/locales.ts'

export const isMarketSol = (market: Market) => CHARTER_MARKETS.includes(market)
export const isMarketRolfs = (market: Market) => !CHARTER_MARKETS.includes(market)
export const isMarketRolfsTours = (market: Market) => market === Markets.ENGLISH
export const marketToConfig = (market: string) => {
  const entry = Object.entries(MARKETS).find(([_, brand]) => brand.market === market)
  return entry?.[1]
}
export const marketToAuthChannel = (market: Market) => MARKETS[market as keyof typeof MARKETS].authChannel
export const marketToEidMethod = (market: Market) => MARKETS[market as keyof typeof MARKETS].eidMethod
export const marketToPhoneDialCode = (market: Market) => MARKETS[market as keyof typeof MARKETS].phoneDialCode
export const marketToAppConfig = (market: Market) => MARKETS[(isMarketSol(market) ? market : Markets.SWEDISH) as keyof typeof MARKETS]
